import "./style.scss";
import * as React from "react";
import { withRouter } from "react-router-dom";
import { MERCHANT_ID_REGEXP } from "../../../common/constants";
import { ICurrentUserProps, ICurrentUserActions } from "./container";

class CurrentUser extends React.Component<
  ICurrentUserProps & ICurrentUserActions & RouterChildProps,
  any
> {
  componentWillMount() {
    if (!this.props.permit) this.props.userLogin();
  }

  handleLogout() {
    this.props.userLogout();
  }

  getMerchant() {
    if (
      !this.props.merchant_name &&
      MERCHANT_ID_REGEXP.test(this.props.location.pathname)
    ) {
      let id = parseInt(
        this.props.location.pathname.match(MERCHANT_ID_REGEXP)[1]
      );
      if (!isNaN(id)) {
        this.props.getMerchant(id);
      }
    }
  }

  render() {
    this.getMerchant();
    let spacer_class_name = !this.props.merchant_name
      ? "merchant-spacer-hidden"
      : "merchant-spacer";

    return (
      <div className="current-user">
        <div className="merchant-name">
          <span>{this.props.merchant_name}</span>
          <span className={spacer_class_name}>-</span>
        </div>
        <div className="username">{this.props.user.name}</div>
        <a onClick={this.handleLogout.bind(this)}>Logout</a>
      </div>
    );
  }
}

export default withRouter(CurrentUser as any);



// WEBPACK FOOTER //
// ./client/modules/User/components/CurrentUser/component.tsx